import React from "react";
import { Link } from "react-router-dom";

/**
 * GameEdge brand logo (full wordmark + mark).
 * `size` sets the height in px (width is auto via SVG viewBox).
 * `to` makes it a Link; omit for a plain img.
 */
export const Logo = ({ size = 28, to, className = "", testid = "logo" }) => {
  const img = (
    <img
      src="/logo.svg"
      alt="GameEdge"
      style={{ height: size }}
      className={`block w-auto select-none ${className}`}
      draggable={false}
    />
  );
  if (to) {
    return (
      <Link to={to} data-testid={testid} className="inline-flex items-center">
        {img}
      </Link>
    );
  }
  return <span data-testid={testid}>{img}</span>;
};

/** Mark-only (icon) variant — uses favicon svg. */
export const LogoMark = ({ size = 32, className = "" }) => (
  <img
    src="/favicon.svg"
    alt="GameEdge"
    style={{ height: size }}
    className={`block w-auto select-none ${className}`}
    draggable={false}
  />
);
